import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { SimpleTab } from '../../../../../../../../CommonComponents/OPL/Tab/SimpleTab';
import { MonteCarloTab } from '../../MonteCarlo.meta';

interface Props {
  activeView: MonteCarloTab;
  setActiveView(tab: MonteCarloTab): void;
}

export const MonteCarloTabSection = ({ activeView, setActiveView }: Props) => {
  return (
    <Box display="flex" mt="16" mb="16">
      <SimpleTab
        isActive={activeView === MonteCarloTab.SummaryOfTrials}
        onClick={() => setActiveView(MonteCarloTab.SummaryOfTrials)}
      >
        Summary of Trials
      </SimpleTab>
      <SimpleTab
        isActive={activeView === MonteCarloTab.MarketScenarios}
        onClick={() => setActiveView(MonteCarloTab.MarketScenarios)}
        ml="8"
      >
        Market Scenarios
      </SimpleTab>
    </Box>
  );
};
